export const HKD = 'hkd';
export const MALE = 'male';
export const FEMALE = 'female';
export const SMOKER = 'smoker';
export const NON_SMOKER = 'non-smoker';
export const DEFAULT_PRODUCT_TYPE = 'vhis';
export const VALID_PRODUCT_TYPES = ['accidental-medical', 'vhis'];
export const PRODUCT_TYPE_MAPPING = {
  'accidental-medical': '意外醫療保險',
  vhis: '自願醫保',
};
export const DESCRIPTION_MAPPING = {
  'accidental-medical':
    '毋須留下個人資料，亦可預先估計「保泰意外保險-觸木保」的每月保費，立即免費報價！',
  vhis:
    '毋須留下個人資料，亦可預先估計Bowtie自願醫保「標準計劃」及「靈活計劃」保費，立即免費報價！',
};
export const SUM_ASSURED_STEP = 100000;
export const SUM_ASSURED_DEFAULT = 1000000;
export const INITIAL_RANGE = {
  min: 200000,
  max: 8000000,
};
